import React from 'react'
import styled from 'styled-components'
import {AiOutlineGithub} from 'react-icons/ai'

const Header = () => {
  return (
    <StyledHeader>
                <div className="head-container">
                    <div className="name-container">
                        <h5>
                            SEGUN TUASE 👨🏿‍💻
                        </h5>
                        <h1>
                            SOFTWARE DEVELOPER
                        </h1>
                    </div>
                    <div className="nav-container">
                        <ul className="nav-list">
                            <a href="#about"><li className="nav-item">About Me</li></a>
                            <a href="#works"><li  className="nav-item">Works</li></a>
                            <a href="#contact" className="nav-item"><li>Get in touch</li></a>
                           <a href="https://github.com/tuasegun"> <li className="nav-item"><AiOutlineGithub/></li></a>
                        </ul>
                    </div>
                </div>
    </StyledHeader>

  )
}

export default Header

const StyledHeader = styled.div`
    .head-container{
        padding: 2.75rem 10% 4rem 10%;
        @media(max-width: 768px){
            padding-left: 5%;
        }
        .name-container{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding-bottom: 1.3rem;
            @media(max-width: 768px){
                justify-content: flex-start;
                align-items: flex-start;
                padding-bottom: 0.625rem;
            }
            h5{
                text-align: center;
                font-family: 'Nunito', sans-serif;
                font-weight: 600;
                font-size: 2.1875rem;
                background-color: #FFD05880;
                padding: 0.5rem;
                line-height: 2.54rem;

                @media(max-width: 768px){
                    font-size: 1.125rem;
                    line-height: 1.534375rem;
                }
            }
            h1{
                text-align: center;
                font-family: 'Space Grotesk', sans-serif;
                font-weight: 500;
                font-size: 4.375rem;
                line-height: 5rem;
                @media(max-width: 768px){
                    text-align: left;
                    font-size: 1.25rem;
                    line-height: 2.4rem;
                }
            }

            border-bottom:  4px solid #000000;;
        }
        .nav-container{
            display: flex;
            justify-content: flex-end;
            @media(max-width: 768px){
                   justify-content: flex-start;
            }
            ul{
                display: flex;
                list-style: none;
                padding-top: 1.4375rem;
                column-gap: 2.5rem;
                @media(max-width: 768px){
                   padding-top: 0.5rem;
                   column-gap: 1rem;
                }
                a{
                    text-decoration: none;
                    color: #000000;

                    &:hover::after{
                        width: 100%;
                        right: 0;
                    }

                    &::after{
                        background: none repeat scroll 0 0 transparent;
                        bottom: 0;
                        content: "";
                        display: block;
                        height: 4px;
                        right: 0;
                        background: #000000;
                        transition: width .5s ease 0s, right .5s ease 0s;
                        width: 0;
                    }

                }
                li{
                    font-family: 'Space Grotesk', sans-serif;
                    font-weight: 500;
                    font-size: 1.875rem;
                    line-height: 2.375rem;
                    @media(max-width: 768px){
                    text-align: left;
                    font-size: 1rem;
                    line-height: 1.9rem;
                    }
                }
                
            }
        }
    }
`